import axios from 'axios'
import url from '../urls'

export default {
  add (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.VocClozeAssignmentUrl, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getByStudentId (_context, studentIdOrParams) {
    const params =
      studentIdOrParams && typeof studentIdOrParams === 'object'
        ? studentIdOrParams
        : { studentId: studentIdOrParams }
    return new Promise((resolve, reject) => {
      axios
        .get(url.VocClozeAssignmentUrl, { params })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getOverview (_context, studentIdOrParams) {
    const params =
      studentIdOrParams && typeof studentIdOrParams === 'object'
        ? studentIdOrParams
        : { studentId: studentIdOrParams }
    return new Promise((resolve, reject) => {
      axios
        .get(`${url.VocClozeAssignmentUrl}/overview`, { params })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getById (_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url.VocClozeAssignmentUrl}/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
}
